module.exports = __webpack_public_path__ + "static/sport/middle-center.65f1b1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport5/middle-center.png
// module id = 1D7e
// module chunks = 0